export const TOGGLE_SUPORT_SUBJECT_MODEL = "TOGGLE_SUPORT_SUBJECT_MODEL";
export const DONATE_SUCCESS_MODEL = "DONATE_SUCCESS_MODEL";

